import type { FarmState, Lote } from '../../domain/model';

export function lotMetrics(state: FarmState, lot: Lote) {
  const feed = state.alimentacion.filter(record => record.loteId === lot.id);
  const deaths = state.mortalidad.filter(record => record.loteId === lot.id);
  const feedPounds = feed.reduce((total, record) => total + record.libras, 0);
  const gainedPounds = lot.historial.reduce((total, record) => {
    const exitWeight = Number(record.pesoSalida) || 0;
    return exitWeight > 0 ? total + exitWeight - (Number(record.pesoEntrada) || 0) : total;
  }, 0);
  return {
    feed,
    deaths,
    feedPounds,
    gainedPounds,
    conversion: gainedPounds > 0 ? (feedPounds / gainedPounds).toFixed(2) : '—',
    totalDeaths: deaths.reduce((total, record) => total + (record.cantidad || 1), 0),
  };
}
